import React from "react";
import { ArrowRight, CircleCheck, Settings, ShieldCheck, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EngenhariaDeEquipamentos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = [{
    icon: <ShieldCheck className="w-5 h-5 text-primary" />,
    text: "Alta Durabilidade"
  }, {
    icon: <Zap className="w-5 h-5 text-primary" />,
    text: "Eficiência Energética"
  }, {
    icon: <Settings className="w-5 h-5 text-primary" />,
    text: "Manutenção Simplificada"
  }];
  return <section id="engenharia-de-equipamentos" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none">
        {}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)`,
        backgroundSize: "40px 40px"
      }} />
        
        {}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/20 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent/10 rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div ref={ref} className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium w-fit">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                </span>
                Tecnologia DOCTORICE
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1]">
                Fabricação Própria e <span className="text-primary">Alta Performance</span>
              </h1>
              
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed">
                Engenharia de precisão para aplicações críticas. Desenvolvemos equipamentos robustos, projetados para garantir a máxima confiabilidade operacional em ambientes hospitalares, laboratoriais e industriais.
              </p>
            </div>

            {}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
              {benefits.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                  <div className="p-2 rounded-lg bg-card border border-border shadow-sm">
                    {item.icon}
                  </div>
                  <span className="font-medium text-sm">{item.text}</span>
                </div>)}
            </div>

            {}
            <div className="flex flex-wrap gap-4 pt-4">
              <Button size="lg" className="h-12 px-8 text-base shadow-lg shadow-primary/20" asChild>
                <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground rounded-md has-[>svg]:px-4 h-12 px-8 text-base shadow-lg shadow-primary/20 !bg-[hsl(175,77%,26%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">Falar com engenharia</Link>
              </Button>
              <Button size="lg" variant="outline" className="h-12 px-8 text-base bg-transparent border-primary/20 hover:bg-primary/5" asChild>
                <Link to="/EquipmentPage">
                  Ver equipamentos
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`relative lg:h-[600px] flex items-center justify-center transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute w-[80%] h-[80%] border border-primary/10 rounded-full animate-[spin_60s_linear_infinite]" />
            <div className="absolute w-[60%] h-[60%] border border-dashed border-primary/20 rounded-full animate-[spin_40s_linear_infinite_reverse]" />

            {}
            <div className="relative z-10 w-full max-w-[500px] animate-[float_6s_ease-in-out_infinite]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/doctorice_equipment_hero.png" alt="Equipamento de Refrigeração Doctorice de Alta Performance" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" />
              
              {}
              <div className="absolute -bottom-6 -left-6 md:bottom-10 md:-left-10 bg-card/80 backdrop-blur-md border border-border p-4 rounded-xl shadow-xl max-w-[200px]">
                <div className="flex items-start gap-3">
                  <div className="bg-green-500/20 p-2 rounded-full text-green-500">
                    <CircleCheck className="w-5 h-5" />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-foreground">100% Testado</p>
                    <p className="text-xs text-muted-foreground">Controle de qualidade rigoroso em fábrica.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </section>;
}